<template>
  <div>
    <ThePageHeader :title="'GINOP Plusz & Széchenyi Terv Plusz'" />

    <div class="text">

      <!-- ==================== ÚJ PROJEKT – LEGFELÜL ==================== -->
      <div>
        <div class="text-xs-center mb-4">
          <b>Sajtóközlemény</b><br>
          <b>Technológiai fejlesztés a Körös PRINT-PACK Kft.-nél</b><br>
        </div>

        <p>
          <strong>GINOP Plusz-1.4.3-25 – Nemzeti Bajnokok – Zöld és digitális átállást célzó egyműveletes kombinált Hitelprogram</strong>
        </p>

        <p><strong>Technológiai fejlesztés a Körös PRINT-PACK Kft.-nél</strong></p>

        <ul class="no-bullets">
          <li><strong>Kedvezményezett neve:</strong> Körös PRINT-PACK Nyomdaipari és Csomagolástechnikai Kft.</li>
          <li><strong>Projekt címe:</strong> Technológiai modernizáció, kapacitásbővítés és energetikai korszerűsítés a Körös PRINT-PACK Kft.-nél</li>
          <li><strong>Szerződött támogatás összege:</strong> 554 150 000 Ft (azaz Ötszázötvennégy millió százötvenezer forint)</li>
          <li><strong>A projekt tervezett befejezési dátuma:</strong> 2026.12.31.</li>
          <li><strong>Projekt azonosító száma:</strong> GINOP Plusz-1.4.3-24-H-CNZB1-/125813/2026/339205/001</li>
        </ul>

        <p><strong>A projekt tartalmának bemutatása:</strong></p>

        <p>
          A Körös PRINT-PACK Kft. jelen beruházás keretében a nyomdaipari gyártási és logisztikai 
          kapacitásának komplex bővítését, a technológiai hatékonyság növelését, valamint a működési 
          költségek környezettudatos csökkentését valósítja meg.
        </p>

        <p>
          A projekt technológiai pilléreként beszerzésre kerül 1 db LK106EMT automata stancoló és prégelő berendezés, 
          valamint 1 db KYD-1080C automata kitörő berendezés raklapemelővel. Ezek a csúcstechnológiás gépek lehetővé teszik 
          a gyártási folyamatok automatizálását, a megmunkálási pontosság növelését és a kibocsátási volumen jelentős növelését 
          a csomagolóanyag-gyártás területén.
        </p>

        <p>
          A megnövekedett termelési kapacitás kiszolgálása és a logisztikai folyamatok optimalizálása érdekében a beruházás 
          magában foglalja <strong>egy új, 512 m² alapterületű raktárépület kivitelezését is. Az infrastrukturális fejlesztést egy 
          modern Mecalux rakodólapos állványrendszer kialakítása</strong> egészíti ki, amely biztosítja az alapanyagok és a késztermékek 
          szisztematikus, helytakarékos és biztonságos tárolását, jelentősen felgyorsítva a belső anyagmozgatást.
        </p>

        <p>
          A technológiai és infrastrukturális modernizáció mellett a vállalkozás nagy hangsúlyt fektet az energiahatékonyságra is: 
          a projekt részeként egy korszerű napelemes tároló rendszer kerül kiépítésre. A megújuló energiaforrás alkalmazásával 
          a termelő és logisztikai létesítmények villamosenergia-igényének jelentős része zöldenergiával lesz lefedhető, amely 
          csökkenti a cég ökológiai lábnyomát és növeli a piaci versenyképességét.
        </p>

        <div class="text-xs-center mt-4">
          <b>A megvalósulás helyszíne:</b><br>
          5600 Békéscsaba, Orosházi u. 32.
        </div>
      </div>

      <!-- Régi tanúsítvány kép -->
      <a href="/img/certificates/plus/kep1.jpg" target="_blank">
        <img src="/img/certificates/plus/kep1.jpg" style="width: 100%;" class="my-4">
      </a>

      <hr class="my-5">

      <!-- ==================== RÉGI PROJEKT (VÁLTOZATLAN) ==================== -->
      <div>
        <div class="text-xs-center mb-2">
          <b>
            Sajtóközlemény
          </b><br>

          <b>
            Raktárcsarnok építés és technológiai fejlesztés a Kőrös PRINT-PACK Kft.-nál Békéscsabán
          </b><br>
        </div>

        A GINOP-Plusz 1.2.1-21 felhívás keretében a Kőrös Print-Pack Kft. 194,21 millió
        forint feltételesen vissza nem térítendő európai uniós támogatásban részesült.
        A Gazdaságfejlesztési és Innovációs Operatív Program Plusz segítségével a
        Kőrös Print-Pack Kft. raktárterület bővítést, megújuló energia alkalmazását és
        technológiai fejlesztéseket hajt végre.<br>

        <div class="text-xs-center my-2">
          <b>A fejlesztés célja a gyártástechnológia továbbfejlesztése.</b><br>
        </div>

        <b>A fejlesztés eredményeként a Kőrös Print-Pack Kft.:</b><br>

        <ul>
          <li>technológiai fejlesztést eredményező új eszközöket szerez be</li>
          <li>építési beruházást hajt végre</li>
          <li>képzéseken vesz részt</li>
          <li>megújuló energiaforrást hasznosító technológiát alkalmaz</li>
        </ul>

        <div class="text-xs-center mt-2">
          <b>A megvalósulás helyszíne:</b><br>
          5600 Békéscsaba Orosházi u. 32.<br>

          <b>Kedvezményezett neve:</b> Kőrös Print-Pack Kft.<br>

          A projekt a Széchenyi Terv Plusz program keretében valósul meg a 2021. és 2022. évben.<br>

          <b>Projektazonosító:</b> GINOP_PLUSZ-1.2.1-21-2021-01006<br>

          <b>A projekt tényleges befejezési dátuma:</b> 2022.12.05.
        </div>
      </div>

      <!-- Régi tanúsítvány kép -->
      <a href="/img/certificates/plus/SzechenyiTervPlusz_KorosPrint.jpg" target="_blank">
        <img src="/img/certificates/plus/SzechenyiTervPlusz_KorosPrint.jpg" style="width: 100%;" class="my-4">
      </a>

      <!-- Régi befejezés rész -->
      <div class="mt-5">
        <div class="text-xs-center mb-2">
          <b>Sajtóközlemény a projekt befejezéséről</b><br>
          <b>Raktárcsarnok építés és technológiai fejlesztés a Kőrös PRINT-PACK Kft.-nál Békéscsabán</b>
        </div>

        A GINOP-Plusz 1.2.1-21 felhívás keretében a Kőrös Print-Pack Kft. 194,21 millió
        forint feltételesen vissza nem térítendő európai uniós támogatásban részesült.<br><br>

        A projekt keretében végrehajtott beruházások sikeresen befejeződtek, a gépek üzembe helyezésre kerültek 
        és 2022. december 31.-ével a projekt lezárásra került.

        <div class="text-xs-center my-2">
          <b>A fejlesztés célja a gyártástechnológia továbbfejlesztése volt, amely sikeresen megvalósult.</b>
        </div>

        <b>A fejlesztés eredményeként a Kőrös Print-Pack Kft.:</b><br>

        <ul>
          <li>technológiai fejlesztést eredményező új eszközöket szerzett be</li>
          <li>építési beruházást hajtott végre</li>
          <li>képzéseken vett részt</li>
          <li>megújuló energiaforrást hasznosító technológiát alkalmazott</li>
        </ul>

        <div class="text-xs-center mt-2">
          <b>A megvalósulás helyszíne:</b><br>
          5600 Békéscsaba Orosházi u. 32.<br>

          <b>Kedvezményezett neve:</b> Kőrös Print-Pack Kft.<br>

          <b>Projektazonosító:</b> GINOP_PLUSZ-1.2.1-21-2021-01006<br>

          <b>A projekt tényleges befejezési dátuma:</b> 2022.12.05.
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'GinopPluszCombined',
  metaInfo: {
    title: 'GINOP Plusz & Széchenyi Terv Plusz | Körös PRINT-PACK Kft.',
    meta: [
      {
        name: 'description',
        content: 'GINOP Plusz-1.4.3-25 Nemzeti Bajnokok és Széchenyi Terv Plusz projektek - Körös PRINT-PACK Kft.',
      },
    ],
  },
  components: {
    ThePageHeader,
  },
};
</script>

<style scoped>
.text {
  margin: 100px auto 0 auto;
  width: 1000px;
  max-width: 90vw;
  font-size: 18px;
  color: #757575;
  line-height: 1.8;
}

.no-bullets {
  list-style: none;
  padding-left: 0;
}

hr {
  border: 0;
  border-top: 1px solid #ddd;
}
</style>